// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"806eb898","47":"92be8a70","54":"7a30df48","188":"d5e0fe39","263":"4b07d45a","275":"4dbcfe15","396":"c6dd4bea","762":"66926ce7","831":"8694c7a8","884":"f378b4ff","887":"3becb4cf","992":"57a8092c"}[chunkId] + ".js";
};